<div class="container">
    <div class="header">
        <h2>Registration complete!</h2>
        <p class="primary-text">You have successfully registered your account.</p>
    </div>

    <ds-button
        (buttonClick)="onLoginClicked()"
        [isLoading]="isLoading" 
        class="button-submit" 
        [processingText]="'Logging in...'" >
        Log In
    </ds-button>
</div>